<template>
  <div class="ncrm-workflow-detail">
    <v-card class="ncrm-workflow-detail__header pa-4">
      <div class="d-flex flex-wrap align-center justify-space-between ga-3">
        <div class="min-w-0">
          <div class="d-flex align-center ga-2">
            <v-btn icon="mdi-arrow-left" variant="text" size="small" @click="$emit('back')" />
            <div class="text-h6 ncrm-text-strong ncrm-workflow-detail__title">
              {{ workflow.name }}
            </div>
          </div>
          <div class="text-body-2 text-medium-emphasis mt-1">
            {{ $t("ncrm.workflows.detail.subtitle") }}
          </div>
        </div>
        <v-btn color="primary" variant="tonal" @click="$emit('edit-workflow', workflow)">
          <v-icon start>mdi-pencil-outline</v-icon>
          {{ $t("ncrm.workflows.actions.editWorkflow") }}
        </v-btn>
      </div>
      <div class="d-flex flex-wrap ga-2 mt-4">
        <v-chip color="primary">
          {{ $t("ncrm.workflows.detail.template") }}: {{ templateName }}
        </v-chip>
        <v-chip color="info">
          {{ $t("ncrm.workflows.detail.apiSource") }}: ncrm_company
        </v-chip>
        <v-chip color="neutral">
          {{ $t("ncrm.workflows.detail.version") }}: {{ workflow.version }}
        </v-chip>
      </div>
    </v-card>
    <NcrmWorkflowNodeRail
      v-model:selected-node-key="selectedNodeKey"
      :nodes="nodes"
      :api-node-key="apiNodeKey"
      :duplicate-node-key="duplicateNodeKey"
      :data-enrichment-node-key="dataEnrichmentNodeKey"
      :crm-write-node-key="crmWriteNodeKey"
      :lead-board-node-key="leadBoardNodeKey"
      :api-summary="{}"
      :auto-sync-settings="{}"
      :dedup-auto-run-settings="{}"
      :enrichment-settings="{}"
      :crm-write-settings="{}"
      :lead-board-settings="{}"
      @edit-node="$emit('edit-node', $event)"
    />
    <NcrmContactNormalizationQueue
      :workflow-instance-id="workflow.id"
      :node-key="selectedNodeKey"
    />
  </div>
</template>

<script>
import {
  WORKFLOW_NODE_KEYS,
  WORKFLOW_TEMPLATE_KEYS,
  createWorkflowNodeDefinitions,
} from "@/Utile/ncrmWorkflows.mjs";
import NcrmContactNormalizationQueue from "@/components/ncrm/workflows/NcrmContactNormalizationQueue.vue";
import NcrmWorkflowNodeRail from "@/components/ncrm/workflows/NcrmWorkflowNodeRail.vue";

export default {
  name: "NcrmContactNormalizationWorkflowDetail",
  components: {
    NcrmContactNormalizationQueue,
    NcrmWorkflowNodeRail,
  },
  props: {
    workflow: { type: Object, required: true },
    templateName: { type: String, default: "" },
  },
  emits: ["back", "edit-workflow", "edit-node"],
  data() {
    return {
      selectedNodeKey: WORKFLOW_NODE_KEYS.PHONE_NORMALIZATION,
    };
  },
  computed: {
    apiNodeKey() { return WORKFLOW_NODE_KEYS.API_IMPORT; },
    duplicateNodeKey() { return WORKFLOW_NODE_KEYS.DUPLICATE_CHECK; },
    dataEnrichmentNodeKey() { return WORKFLOW_NODE_KEYS.DATA_ENRICHMENT; },
    crmWriteNodeKey() { return WORKFLOW_NODE_KEYS.CRM_WRITE; },
    leadBoardNodeKey() { return WORKFLOW_NODE_KEYS.LEAD_BOARD_ADD; },
    nodes() {
      return createWorkflowNodeDefinitions(this.$t, WORKFLOW_TEMPLATE_KEYS.CONTACT_NORMALIZATION);
    },
  },
};
</script>

<style src="./NcrmWorkflowDetail.css" scoped></style>
